import $ from 'jquery';

import Utils from '../global/Utils';
import Api from '../global/Api';

let current = '';

export default class TopBar {
  constructor(o) {
    this.obj = $(o);
    this.el = $(o).get();
    this.addListeners();
  }

  addListeners() {
    let modalObj = $('.modal.region-selector');
    let navigationObj = this.obj.find('.navigation');

    modalObj.find('.icon-cross').on('click', function () {
      closeModal();
      return false;
    });

    this.obj.find('.lang-selector').on('click', function () {
      openModal();
      navigationObj.removeClass('show');
      $('body').addClass('noscroll');

      $.ajax({
        dataType: 'json',
        url: Api.getSites(),
        success: function (data) {
          if (data) {
            let lis = '';
            let globalUrl = '';

            data.forEach(function (obj) {
              if (!obj.active) {
                lis += '<li><a href="' + obj.url + '">' + obj.displayName + '</a></li>';
                globalUrl = obj.url;
              }
            });

            const langCodes = [
              'en', 'no', 'us', 'dk', 'se', 'fi', 'de', 'fr', 'nl',
              'au', 'en_ca', 'fr_ca', 'ja_jp', 'jp', 'kr', 'ja'
            ];

            const url = new URL(globalUrl, window.location.origin);
            let pathSegments = url.pathname.split('/').filter(segment => segment.length > 0);
            const last = pathSegments.at(-1)?.toLowerCase();
            const lastTwo = pathSegments.slice(-2).join('_').toLowerCase();

            if (langCodes.includes(lastTwo)) {
              pathSegments = pathSegments.slice(0, -2);
            } else if (langCodes.includes(last)) {
              pathSegments = pathSegments.slice(0, -1);
            }

            url.pathname = '/' + pathSegments.join('/');
            url.search = '?global=true';
            globalUrl = url.toString();

            lis += '<li><a href="' + globalUrl + '">Global</a></li>';
            $('.region-selector').find('ul').html(lis);
          }
        }
      });

      return false;
    });

    function openModal() {
      modalObj.addClass('show');
      modalObj.removeAttr('inert');
      modalObj.attr('aria-hidden', 'false');

      const firstLink = modalObj.find('a[href]').get(0);
      if (firstLink) firstLink.focus();

      $(document).on('keydown.modalEscape', function (e) {
        if (e.key === 'Escape') {
          closeModal();
        }
      });
    }

    function closeModal() {
      modalObj.removeClass('show');
      modalObj.attr('inert', '');
      modalObj.attr('aria-hidden', 'true');
      $('body').removeClass('noscroll');
      $(document).off('keydown.modalEscape');
    }

    navigationObj.find('.icon-cross').on('click', function () {
      navigationObj.removeClass('show');
      $('body').removeClass('noscroll');
      return false;
    });

    this.obj.find('.icon-burger').on('click', function () {
      navigationObj.addClass('show');
      $('body').addClass('noscroll');
      return false;
    });
  }
}
